import { autorun } from 'mobx';

import { createBiLogger } from '../../viewer';
import { ElementId } from './constants';
import model from './model';

export default model.createController(({ $bind, $widget, flowAPI, $props, $w }) => {
  const { panoramaClient, bi } = flowAPI;
  const { t } = flowAPI.translations;
  const biLogger = createBiLogger(bi);

  return {
    async pageReady() {
      const userStates = $w(`#${ElementId.UserStates}`);
      const { isRTL } = flowAPI.environment;

      autorun(() => userStates.changeState($props.isLoggedIn ? ElementId.LoggedInState : ElementId.LoggedOutState));

      if (isRTL) {
        try {
          ($w(`#${ElementId.LoggedInState}`) as any).customClassList.add('referrals-rtl');
          ($w(`#${ElementId.LoggedOutState}`) as any).customClassList.add('referrals-rtl');
        } catch (error) {
          panoramaClient?.errorMonitor().reportError(error as Error);
          console.error(error);
        }
      }

      $bind(`#${ElementId.LoginButton}`, {
        onClick: () => $widget.fireEvent('login', {}),
      });

      $bind(`#${ElementId.TitleText}`, {
        text: () => $props.title,
        collapsed: () => !$props.title,
        ...(isRTL && {
          html: () => `<h2 style="text-align: right !important;">${$props.title}</h2>`,
        }),
      });

      $bind(`#${ElementId.DescriptionText}`, {
        html: () => $props.description,
        collapsed: () => !$props.description,
      });

      $bind(`#${ElementId.ExplanationsText}`, {
        collapsed: () => true,
      });

      $bind(`#${ElementId.CopyLink}`, {
        enabled: () => !$props.isLinkLoading,
        text: () => $props.referralLink,
        label: () => t('refer-friend-page.text-input-area-label'),
        onCopy() {
          biLogger.referringCustomerAction('Copy link');
        },
        onInputClick() {
          biLogger.referringCustomerAction('Link Text Input Click');
        },
      });

      $bind(`#${ElementId.SocialBar}`, {
        pageToShare: () => `https://${$props.referralLink}`,
      } as any);
    },
    exports: {},
  };
});
